export const findPostitoimipaikka = (postinumero, postinumerot, language) => {
    const postinumeroUri = `posti_${postinumero}`;
    return postinumerot.find((p) => p.uri === postinumeroUri)?.nimi[language];
};
